// extracted by css-extract-rspack-plugin
export default {"list":"list-CuAnJU","tag":"tag-DR8pow","remove":"remove-IiLJwN","icon-button":"icon-button-OlunbI","iconButton":"icon-button-OlunbI"};